import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { PaddingGroup } from 'src/editor/shared/settings/groups/padding'
import { MarginGroup } from 'src/editor/shared/settings/groups/margin'
import { PaddingType } from 'common/types/styleTypes'
import { MarginType } from 'common/types/styleTypes'
import { useTranslation } from 'react-i18next'

interface SizeAndPositionGroupProps {
  title?: React.ReactNode
  margin?: Partial<MarginType> | MarginType | undefined
  updateMargin?: (margin: Partial<MarginType>) => void
  padding?: PaddingType | undefined
  updatePadding?: (padding: PaddingType) => void
}

export const SizeAndPositionGroup = (props: SizeAndPositionGroupProps) => {
  const { t } = useTranslation()

  const {
    title = 'settings_styles.size_and_position.label',
    updateMargin,
    margin,
    updatePadding,
    padding,
  } = props

  const isMarginPropPassed = 'margin' in props
  const isPaddingPropPassed = 'padding' in props

  return (
    <>
      <GroupTitle>{typeof title === 'string' ? t(title) : title}</GroupTitle>
      {isPaddingPropPassed && updatePadding && (
        <PaddingGroup padding={padding} update={updatePadding} />
      )}
      {isMarginPropPassed && updateMargin && (
        <MarginGroup margin={margin} update={updateMargin} />
      )}
    </>
  )
}
